module.exports = {"custom-data":{"add_variable":"Add a new variable","fields":{"name":{"placeholder":"E.g. 'age'"},"value":{"placeholder":"Enter the value"}}}}